import * as React from "react";
import {Fragment, useLayoutEffect} from "react";
import {Alert} from "@mui/material";
import {CheckCircleRounded} from "@mui/icons-material";
import {useShoppingCart} from "../context/ShoppingCartContext";
import {Link} from "react-router-dom";

const CheckOutForm3 = ({message, seqno}) => {

  const { setCartItems } = useShoppingCart();

  useLayoutEffect(() => {
    window.scrollTo(0, 0)


  }, [setCartItems])


  return (
    <Fragment>
    {
      !message ?
        <div className="container">
      <div className="content">
        <div className="checkout-page">

          <div className="shipping-address row mb-5">
            <h2 className="ps-0 ms-0">Order Complete</h2>
            <hr/>

            <div className="address-details row">

              <div className="col-12">
                <div className="notify-details">
                  <CheckCircleRounded style={{color: 'green'}}/> <strong>The iStore team would like to thank you for your order.</strong>
                </div>
              </div>

            </div>

          </div>

          <div className="shipping-address row mb-5">
            <div className="row align-items-end p-0 mb-2">
              <div className="col "><h2 className="ps-0 ms-0">Your order number is: {seqno}</h2></div>
            </div>

            <div className="row form-shipping">
              <p>Your order is now being processed by our friendly staff.</p>
              <p>An email notification has been sent to you with your order details. If you do not receive this email within 10 minutes, please feel free to contact the office to confirm by phone.</p>
              <p><Link to="/">Go back to the homepage</Link></p>
            </div>

          </div>
        </div>
      </div>
    </div>
        : <Alert severity="error">{message}</Alert>
    }
    </Fragment>
  );
};

export default CheckOutForm3;
